import { Dispatch } from "redux";
import { AxiosRequestConfig, AxiosResponse } from "axios";
import { ApexApiError } from "apex-ui-services";
import { HttpResponseStatusCodes } from "../constants/HttpResponseStatusCodes";
import { MISBILLED_REQUEST_FAILED, TEMPORARILY_UNAVAILABLE } from "./constants";
import { getMisbilledTrades as getMisbilledTradesApi } from "../api/misbilledTradesApi";

export const GET_MISBILLED_TRADES = "GET_MISBILLED_TRADES";
export const GET_MISBILLED_TRADES_SUCCESS = "GET_MISBILLED_TRADES_SUCCESS";
export const GET_MISBILLED_TRADES_FAILURE = "GET_MISBILLED_TRADES_FAILURE";

export const getMisbilledTrades = (
  dispatch: Dispatch,
  startDate: string,
  endDate: string,
  config: AxiosRequestConfig,
  onError: (error: string) => void
) => {
  dispatch({ type: GET_MISBILLED_TRADES });
  getMisbilledTradesApi(startDate, endDate, config)
    .then((response: AxiosResponse) => {
      dispatch({
        type: GET_MISBILLED_TRADES_SUCCESS,
        records: response.data.records,
      });
    })
    .catch((error: ApexApiError) => {
      const httpResponseStatus = error.response?.status;
      const errorMessage =
        httpResponseStatus &&
        httpResponseStatus >= HttpResponseStatusCodes.InternalServerError
          ? TEMPORARILY_UNAVAILABLE
          : MISBILLED_REQUEST_FAILED;
      dispatch({ type: GET_MISBILLED_TRADES_FAILURE });
      onError(errorMessage);
    });
};
